import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M12,4a8,8,0,0,1,7.89,6.7A1.53,1.53,0,0,0,21.38,12h0a1.5,1.5,0,0,0,1.48-1.75,11,11,0,0,0-21.72,0A1.5,1.5,0,0,0,2.62,12h0a1.53,1.53,0,0,0,1.49-1.3A8,8,0,0,1,12,4Z",
    class: "spinner-circle",
    fill: "currentColor"
  })
], -1)
const _hoisted_2 = [
  _hoisted_1
]

import { PropType } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'tir-pm-spinner',
  props: {
  /**
   * Размер
   */
  size: {
    type: String as PropType<"big" | "regular" | "small">,
    default: "regular",
  },
},
  setup(__props) {

const props = __props;



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["spinner", {
      'spinner--big': props.size == 'big',
      'spinner--regular': props.size == 'regular',
      'spinner--small': props.size == 'small',
    }])
  }, _hoisted_2, 2))
}
}

})